/* eslint-disable react/require-default-props */

import React from 'react';
import { connect } from 'react-redux';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertPaymentTypeDataToCashCardSplitTableData } from 'reports/utils';

class CashCardSplitStylistTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const currencyAbbr = this.props.currency;

    return (
      <div>
        <div id="payment-by-total">
          <ReportTableContainer
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            title="Payment Split by Staff member: Total Revenue"
            data={{
              rows: convertPaymentTypeDataToCashCardSplitTableData(
                this.props.stylists.filter((s) => s.total_revenue !== 0),
                'total',
                currencyAbbr,
              ),
            }}
          />
        </div>
        <div id="payment-by-services">
          <ReportTableContainer
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            title="Payment Split by Staff member: Services"
            data={{
              rows: convertPaymentTypeDataToCashCardSplitTableData(
                this.props.stylists.filter((s) => s.total_revenue !== 0),
                'services',
                currencyAbbr,
              ),
            }}
          />
        </div>
        <div id="payment-by-products">
          <ReportTableContainer
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            title="Payment Split by Staff member: Products"
            data={{
              rows: convertPaymentTypeDataToCashCardSplitTableData(
                this.props.stylists.filter((s) => s.total_revenue !== 0),
                'products',
                currencyAbbr,
              ),
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
});

const CashCardSplitStylistTableHoc = connect(mapStateToProps)(CashCardSplitStylistTable);

export default CashCardSplitStylistTableHoc;
